<template lang="pug">
  #email-archive.pb-6
    MemberCenterAdminEmailArchiveTable(
      :archived-email-object="archivedEmails"
      :fetch-action="fetchAction"
      :loading="!archivedEmailsLoaded"
      :featuredChallenges="featuredChallenges"
    )
</template>

<script>
import MemberCenterAdminEmailArchiveTable from "@@/MemberCenterAdmin/MemberCenterAdminEmailArchiveTable";

export default {
  name: "MemberCenterAdminEmailArchive",

  components: {
    MemberCenterAdminEmailArchiveTable
  },

  props: {
    archivedEmails: {
      type: Object,
      required: true
    },
    archivedEmailsLoaded: {
      type: Boolean,
      required: true
    },
    fetchAction: {
      type: Function,
      required: true
    },
    featuredChallenges: {
      type: Array,
      default: null
    }
  }
};
</script>

<style lang="sass" scoped></style>
